<template>
  <div class="referral-action-with-input-box__container">
    <h3>{{ title }}</h3>
    <p>{{ description }}</p>
    <section :class="isValidate ? 'validate' : 'unvalidate'">
      <input
        v-model="inputValue"
        ref="inputRef"
        type="text"
        :placeholder="[[ inputPlaceholder ]]" 
        :disabled="isInputDisabled"
        @focus="focusController"
      >
      <button
        ref="buttonRef"
        @click="clickAction"
      >
        {{ inputButtonLabel }}
      </button>
    </section>
    <p
      :style="{visibility : isValidate ? 'hidden' : 'visible'}"
      class="unvalidate-message"
    >
      {{ validateErrorMessage }}
    </p>
  </div>
</template>

<script>
export default {
  mounted(){
    if(Object.keys(this.$refs).length){
      const { offsetWidth } = this.$refs.buttonRef;
      this.$refs.inputRef.style.width = `calc(100% - ${offsetWidth}px - 5px)`;
    }
    if(this.defaultValue){
      this.$refs.inputRef.value = this.defaultValue;
    }
    if(this.boxInputValueCopyEvent){
      this.$refs.inputRef.addEventListener('copy', this.boxInputValueCopyEvent);
    }
  },
  watch:{
    boxDefaultValue: function(value){
      this.$refs.inputRef.value = value;
    }
  },
  data(){
    return {
      inputValue : '',
      isValidate: true,
    }
  },
  props:{
    boxTitle: {
      type: String,
      default: '타이틀',
    },
    boxDescription: {
      type: String,
      default: '설명',
    },
    boxInputPlaceholder: {
      type: String,
      default: '입력해주세요',
    },
    boxInputButtonLabel: {
      type: String,
      default: '버튼',
    },
    boxInputButtonAction: {
      type: Function,
      default: ()=>{},
    },
    boxDefaultValue: {
      type: String,
      default: undefined,
    },
    boxIsInputDisabled: {
      type: Boolean,
      default: false,
    },
    boxValidatePattern: {
      type: RegExp,
      default: undefined,
    },
    boxValidateErrorMessage: {
      type: String,
      default: 'error message',
    },
    boxInputMultipleValueAction: {
      type: Function,
      default: null,
    },
    boxInputValueCopyEvent: {
      type: Function,
      default: null
    }
  },
  computed:{
    title(){
      return this.boxTitle;
    },
    description(){
      return this.boxDescription;
    },
    inputPlaceholder(){
      return this.boxInputPlaceholder;
    },
    inputButtonLabel(){
      return this.boxInputButtonLabel;
    },
    inputButtonAction(){
      return this.boxInputButtonAction;
    },
    defaultValue(){
      return this.boxDefaultValue; 
    },
    isInputDisabled(){
      return this.boxIsInputDisabled;
    },
    validateErrorMessage(){
      return this.boxValidateErrorMessage;
    }
  },
  methods:{
    async clickAction(){
      let allowNextStep = false;
      if(this.boxInputMultipleValueAction){
        allowNextStep = await this.boxInputMultipleValueAction(this.$refs.inputRef);
      }else{
        allowNextStep = true;
      }
      //TODO: multiple vaule 에 대한 로직도 만들 것.
      if(this.boxValidatePattern && allowNextStep){
        const validateResult = this.boxValidatePattern.test(this.inputValue);
        if(!validateResult){
          this.isValidate = false;
          return;
        }
      }

      if(allowNextStep){
        this.inputButtonAction(this.$refs.inputRef);
      }
    },
    focusController(){
      if(!this.isValidate){
        this.isValidate = true;
        return;
      }
    }
  }
}
</script>

<style lang="scss">
    .referral-action-with-input-box__container{
        width: 100%;
        background-color: #ffffff;
        border-radius: 6px;
        padding: 20px 20px 0 20px;
        h3{
           font-size: 14px;
           font-weight: 500;
           font-stretch: normal;
           font-style: normal;
           line-height: 1.43;
           letter-spacing: -0.8px;
           color: #4a4a4a;
           margin-bottom: 5px;
        }
        p{
            font-size: 12px;
            font-weight: normal;
            font-stretch: normal;
            font-style: normal;
            line-height: 1.5;
            letter-spacing: -0.85px;
            margin-bottom: 15px;
        }
        section{
            display: flex;
            width: 100%;
            height: 50px;
            padding: 0 4px 0 15px;
            border: solid 1px #d3d3d3;
            border-radius: 6px;
            
            &:focus-within{
                border: solid 1px #4a4a4a;
            }

            input{
                cursor: text;
                border: none;
                font-size: 14px;
                margin-right: 5px;
                &::placeholder, &:disabled{
                    color: #b9b9b9;
                    letter-spacing: -0.8px; 
                }
                
                &:disabled{
                   background-color: #ffffff;
                }

            }
            button{
                padding: 10px 12px;
                outline: none;
                border-radius: 8px;
                color: #ffffff;
                background-color: #9b9b9b;
                border: 1px solid #d3d3d3;
                font-size: 15px;
                font-weight: normal;
                font-stretch: normal;
                font-style: normal;
                line-height: normal;
                letter-spacing: -0.86px;
                margin: 2px 0;
                white-space: nowrap;
            }
        }
        .unvalidate{
          border: solid 1px #dc1e00 !important;
        }
        .unvalidate-message{
          color: #dc1e00;
          margin: 4px 0 0 0;
          line-height: 20px;
          height: 20px;
        }
    }
</style>